export default "__VITE_ASSET__0d3cc7d3__"